import { useMutation, useQuery } from "@tanstack/react-query";
import { privateHttp } from "~/config/axios";
import { API_ENDPOINTS } from "~/config/endpoints";

/** 문의사항 구분 */
export type InquiryCategory = "STORE_INFO" | "BIZ_IMPROVE" | "ETC";

/** 문의 처리 상태 */
export type InquiryStatus = "RECEIVED" | "IN_PROGRESS" | "DONE" | "REJECTED";

/** 내 문의 내역 항목 */
export interface MyInquiry {
  id: number;
  category: InquiryCategory;
  categoryLabel?: string | null;
  subType?: string | null;
  companySeq?: number | null;
  companyName?: string | null;
  content: string;
  status: InquiryStatus;
  statusLabel?: string | null;
  answer?: string | null;
  answeredAt?: string | null;
  createdAt: string;
}

export interface InquiryCreateRequest {
  category?: InquiryCategory; // 미지정 시 서버 기본 STORE_INFO
  subType?: string; // 전화번호/영업시간/주소/폐업·이전/기타
  companySeq?: number;
  companyName?: string;
  content: string;
  contact?: string;
}

interface BaseResponseShape {
  statusCode: number;
  message?: string;
}

const createInquiry = async (
  requestData: InquiryCreateRequest,
): Promise<BaseResponseShape> => {
  try {
    const { data } = await privateHttp.post(
      API_ENDPOINTS.USER_INQUIRY.CREATE,
      requestData,
    );
    return data;
  } catch (error) {
    console.error("문의사항 접수 API 호출 에러:", error);
    throw error;
  }
};

/** 매장 정보 수정 및 제안 접수 */
export const useInquiryCreate = () =>
  useMutation({ mutationFn: createInquiry });

const getMyInquiries = async (): Promise<MyInquiry[]> => {
  const { data } = await privateHttp.get(API_ENDPOINTS.USER_INQUIRY.LIST);
  return data?.data ?? [];
};

/** 내 문의 내역 (최신순) */
export const useMyInquiries = () =>
  useQuery({
    queryKey: ["myInquiries"],
    queryFn: getMyInquiries,
    staleTime: 0,
  });
